import {Component, ElementRef, HostListener, OnInit} from '@angular/core';
import {AgendaService} from '../../services/agenda.service';
import {Apointment} from '../../models/apointment.model';
import {CustomerService} from '../../services/customers.service';
import {Customer} from '../../models/customer.model';
import {ConfirmationService, SelectItem} from 'primeng/primeng';

@Component({
  providers: [AgendaService, CustomerService],
  selector: 'app-agenda',
  templateUrl: './agenda.component.html'
})
export class AgendaComponent implements OnInit {
  public correction = 180;
  public tableHeight = 200;
  public events: any[];
  public config: any;
  public display = false;
  public selectedApointment: Apointment;
  public selectedDate: Date;
  public displayNew = false;

  public customerList: SelectItem[];
  public customers: Customer[];
  public newTitle = 'Nieuwe afspraak';
  public newDate: Date = new Date();
  public newCustomer: string;
  public newError: string;

  constructor(private _agendaService: AgendaService, private _elementReference: ElementRef,
              private _customerService: CustomerService, private confirmationService: ConfirmationService) {
    this.config = {
      buttonText: {
        today: 'vandaag'
      },
      monthNames: ['Januari', 'Februari', 'Maart', 'April', 'Mei',
        'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
      dayNames: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
      dayNamesShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    };
  }

  public ngOnInit(): void {
    this.setTableHeight();
    this._customerService.loadAll();
    this._customerService.customers$.subscribe(customers => {
      this.customers = customers;
      if (this.customers.length > 0) {
        this.newCustomer = this.customers[0]._id;
      }
      this.customerList = [];
      this.customers.forEach(customer => {
        this.customerList.push({label: customer.name, value: customer._id});
      });
    });

    this._agendaService.apointments$.subscribe(apointments => {
      this.events = [];
      apointments.forEach(apointment => {
        this.events.push({
          title: apointment.title,
          start: apointment.date,
          allDay: true,
          editable: true,
          apointment: apointment
        });
      });
    });
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event: any) {
    this.setTableHeight();
  }

  public loadEvents(event): void {
    const date = event.view.calendar.getDate();
    this._agendaService.loadAll(`?month=${date.month() + 1}&year=${date.year()}`);
  }

  public eventClick(event): void {
    if (event && event.calEvent && event.calEvent.apointment) {
      this.selectedApointment = event.calEvent.apointment;
      this.selectedDate = new Date(this.selectedApointment.date);
      this.display = true;
    }
  }

  public saveNewApointment(): void {
    if (this.newCustomer && this.newDate && this.newTitle) {
      const newApointment = new Apointment();
      newApointment.title = this.newTitle;
      newApointment.customer = this.customers.find(cust => cust._id === this.newCustomer);
      const day = this.newDate.getDate();
      let dayString = '';
      if (day < 10) {
        dayString = `0${day}`;
      } else {
        dayString = `${day}`;
      }

      const month = this.newDate.getMonth() + 1;
      let monthString = '';
      if (month < 10) {
        monthString = `0${month}`;
      } else {
        monthString = `${month}`;
      }

      const year = this.newDate.getFullYear();
      const dateString = `${year}-${monthString}-${dayString}T00:00:00.000Z`;

      newApointment.date = dateString;
      this._agendaService.create(newApointment);

      this.newCustomer = null;
      this.newTitle = 'Nieuwe afspraak';
      this.newDate = new Date();
      this.newError = null;
      this.newCustomer = this.customers[0]._id;
      this.displayNew = false;
    } else {
      this.newError = 'Niet alle gegevens zijn correct ingevuld';
    }
  }

  public deleteApointment(): void {
    if (this.selectedApointment) {
      this.confirmationService.confirm({
        message: 'Weet u het zeker dat u de afspraak wilt verwijderen?',
        accept: () => {
          this._agendaService.remove(this.selectedApointment._id);
          this.display = false;
        }
      });
    }
  }

  public saveApointment(): void {
    if (this.selectedApointment) {

      const day = this.selectedDate.getDate();
      let dayString = '';
      if (day < 10) {
        dayString = `0${day}`;
      } else {
        dayString = `${day}`;
      }

      const month = this.selectedDate.getMonth() + 1;
      let monthString = '';
      if (month < 10) {
        monthString = `0${month}`;
      } else {
        monthString = `${month}`;
      }

      const year = this.selectedDate.getFullYear();
      const dateString = `${year}-${monthString}-${dayString}T00:00:00.000Z`;
      this.selectedApointment.date = dateString;
      this._agendaService.update(this.selectedApointment);
      this.display = false;
    }
  }

  public eventDrop(event): void {
    if (event && event.event && event.event.apointment && event.event.start && event.event.start._d) {

      const day = event.event.start._d.getDate();
      let dayString = '';
      if (day < 10) {
        dayString = `0${day}`;
      } else {
        dayString = `${day}`;
      }

      const month = event.event.start._d.getMonth() + 1;
      let monthString = '';
      if (month < 10) {
        monthString = `0${month}`;
      } else {
        monthString = `${month}`;
      }

      const year = event.event.start._d.getFullYear();
      const dateString = `${year}-${monthString}-${dayString}T00:00:00.000Z`;
      event.event.apointment.date = dateString;
      this._agendaService.update(event.event.apointment);
    }
  }

  private setTableHeight(): void {
    const top = this._elementReference.nativeElement.getBoundingClientRect().top;
    this.tableHeight = (window.innerHeight - top - this.correction);
  }
}




// WEBPACK FOOTER //
// ./src/app/pages/agenda/agenda.component.ts